export const STATUS_CHANGED_EVENT = "Applicat.Bin_entrepot.Etat.Changed";
export const NOTIFICATION_EVENT = "Applicat.Entrepot_notif.Updated";
export const WEBSOCKET_CONNECTED_EVENT = "WEBSOCKET_CONNECTED";
export const WEBSOCKET_FAILED_EVENT = "WEBSOCKET_FAILED";
